import React, { useState, useContext } from 'react';
import IconButton from '@mui/material/IconButton';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListSubheader from '@mui/material/ListSubheader';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import { ManageSubscription } from './ManageSubscription';
import { PasswordReset } from './PasswordReset';
import { Logout } from './Logout';
import { Contact } from './Contact';
import { MyPatternsLink } from './MyPatternsLink';
import { PatternLibraryLink } from './PatternLibraryLink';
import { PatternMakerLink } from './PatternMakerLink';
import { CommunityLink } from './CommunityLink';
import { AuthContext } from '../../../providers/AuthProvider';
import { AccessContext } from '../../../providers/AccessProvider';
import { ACCESS_TYPES } from '../../../config/constants';
import {
	COLOR_TOPBAR,
	COLOR_DRAWER_HEADER_BG,
	COLOR_DRAWER_BORDER,
	COLOR_DRAWER_ITEM_TEXT,
} from '../../../styles/tokens';

const ACCESS_TYPE_LABELS = {
	[ACCESS_TYPES.LIFETIME]: 'Full Access',
	[ACCESS_TYPES.SUBSCRIPTION_MONTHLY]: 'Subscribed Monthly',
	[ACCESS_TYPES.SUBSCRIPTION_YEARLY]: 'Subscribed Yearly',
	[ACCESS_TYPES.NONE]: 'Unsubscribed',
};

const AccountDrawer = () => {
	const [drawerOpen, setDrawerOpen] = useState(false);
	const { user } = useContext(AuthContext);
	const { accessType } = useContext(AccessContext);

	const HeaderItem = () => {
		return (
			<ListItem
				sx={{
					padding: '12px 20px',
					backgroundColor: COLOR_DRAWER_HEADER_BG,
					borderBottom: `1px solid ${COLOR_DRAWER_BORDER}`,
					justifyContent: 'center',
				}}
				key={'Fore Edge Book Art'}
			>
				<ListItemIcon sx={{ minWidth: '48px' }}>
					<img
						src={process.env.PUBLIC_URL + '/Logo.png'}
						alt="Fore Edge Book Art"
						style={{
							width: '36px',
							height: '36px',
							filter: 'brightness(0) invert(1)',
							opacity: 0.85,
						}}
					/>
				</ListItemIcon>
				<ListItemText
					primary={'Fore Edge Book Art'}
					primaryTypographyProps={{
						fontWeight: '600',
						variant: 'h5',
						sx: {
							color: COLOR_DRAWER_ITEM_TEXT,
							letterSpacing: '0.05em',
						},
					}}
				/>
			</ListItem>
		);
	};

	const EmailItem = () => {
		return (
			<ListSubheader
				sx={{
					backgroundColor: 'transparent',
					paddingTop: '12px',
					paddingBottom: '8px',
				}}
			>
				<Typography
					variant="h5"
					sx={{
						textAlign: 'center',
						lineHeight: 1,
						color: 'rgba(255,255,255,0.85)',
						marginBottom: '2px',
					}}
				>
					{user?.email}
				</Typography>
				{accessType && (
					<Typography
						variant="body1"
						sx={{
							textAlign: 'center',
							lineHeight: '1.2',
							color: 'rgba(255,255,255,0.45)',
						}}
					>
						{ACCESS_TYPE_LABELS[accessType]}
					</Typography>
				)}
			</ListSubheader>
		);
	};

	return (
		<>
			<Drawer
				anchor="right"
				open={drawerOpen}
				onClose={() => {
					setDrawerOpen(false);
				}}
				PaperProps={{
					sx: { backgroundColor: COLOR_TOPBAR, minWidth: '260px' },
				}}
			>
				<List subheader={<HeaderItem />}>
					<EmailItem />
					<Divider sx={{ borderColor: COLOR_DRAWER_BORDER }} />
					<MyPatternsLink
						callBack={() => {
							setDrawerOpen(false);
						}}
					/>
					<PatternLibraryLink
						callBack={() => {
							setDrawerOpen(false);
						}}
					/>
					<PatternMakerLink
						callBack={() => {
							setDrawerOpen(false);
						}}
					/>
					<CommunityLink
						callBack={() => {
							setDrawerOpen(false);
						}}
					/>
					<ManageSubscription
						callBack={() => {
							setDrawerOpen(false);
						}}
					/>
					<PasswordReset
						callBack={() => {
							setDrawerOpen(false);
						}}
					/>
					<Contact />
					<Logout />
				</List>
				<Typography
					sx={{
						textAlign: 'center',
						fontSize: '20px',
						lineHeight: '30px',
						position: 'absolute',
						bottom: '0px',
						width: '100%',
						color: 'rgba(255,255,255,0.3)',
					}}
				>
					{require('../../../../package.json').version}
				</Typography>
			</Drawer>

			<IconButton
				edge="end"
				color="inherit"
				aria-label="Menu"
				onClick={() => {
					setDrawerOpen(true);
				}}
			>
				<AccountCircle />
			</IconButton>
		</>
	);
};

export default AccountDrawer;
